export default __webpack_public_path__ + "static/media/frame543.ff40dc07.svg";